import * as types from './type';

import { Project }  from  '../../services/project';

export function getProject(data){
  return {
    type: types.GET_PROJECT_DETAIL,
    payload: Project.getProject(data),
  };
}

export function getResFeaturedProjects(data) { 
  return {
    type: types.GET_RES_FEATURED_PROJECTS,
    payload: Project.getFeaturedProjects(data),
  };
};
export function getCommFeaturedProjects(data) { 
  return {
    type: types.GET_COMM_FEATURED_PROJECTS,
    payload: Project.getFeaturedProjects(data),
  };
};

export function getProjectTypes(){
  return {
    type: types.GET_PROJECT_TYPES,
    payload: Project.getProjectTypes(),
  };
}

export function getProjectList(data) { 
  return {
    type: types.GET_PROJECTS_WITH_PAGINATION,
    payload: Project.getProjectList(data),
  };
};

export function getFeaturedProjectsWithPagination(data) { 
  return {
    type: types.GET_FEATURED_PROJECTS_WITH_PAGINATION,
    payload: Project.getFeaturedProjectsWithPagination(data),
  };
};
